import EnumDataSource from "utils/enum-data-source.util";
import {
  StatusTransitionCode,
  StatusTransitionFlow,
} from "./status-transition-cell.component";

export const getTransitionsRules = (
  status: StatusTransitionCode,
  allStatuses: EnumDataSource,
  statusTransitions?: StatusTransitionFlow,
  excludeStatuses: StatusTransitionCode[] = []
): StatusTransitionFlow => {
  const excludeStatusCodes = excludeStatuses.map((code) => String(code));
  if (!statusTransitions || !Object.keys(statusTransitions).length) {
    const transitionRules: StatusTransitionFlow = {};
    /*
    NMO: if we haven't any transition restrictions for current status,
    all transitions are allowed
    */
    allStatuses.getOptions(excludeStatuses).forEach((option) => {
      transitionRules[option.value] = allStatuses
        .getCodes()
        .filter((code) => code !== status?.toString());
    });
    transitionRules[""] = allStatuses
      .getCodes()
      .filter((code: string) => !excludeStatusCodes.includes(code));
    return transitionRules;
  }
  if (excludeStatusCodes.length) {
    const transitionRules: StatusTransitionFlow = {};
    for (const [key, value] of Object.entries(statusTransitions)) {
      if (excludeStatusCodes.includes(key)) {
        continue;
      }
      transitionRules[key] = value.filter(
        (code) => !excludeStatusCodes.includes(String(code))
      );
    }
    return transitionRules;
  }
  return statusTransitions;
};
